module.exports = __webpack_public_path__ + "img/car_00035.7e32463c.jpg";